/**
 * @file
 * Old AMD key: `ac/jira/date-picker`
 */

import { show } from './date-picker-utils.tsx';
import type { DatePickerCallback, DatePickerOptions } from './types.tsx';

const defaultPos = { top: 0, left: 0 };

const _options = (options: DatePickerOptions, callback: DatePickerCallback) => {
	const finalOptions = options;

	finalOptions.onSelect = (calendarInstance, date) => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.connectHost.broadcastEvent(
			'jira_date_selected',
			{
				id: callback._context.extension_id,
			},
			{
				isoDate: calendarInstance.date.toISOString(),
				date,
			},
		);

		if (calendarInstance.dateClicked) {
			calendarInstance.callCloseHandler();
		}
	};

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const iframeBox = document
		.getElementById(callback._context.extension_id)
		?.getBoundingClientRect();

	finalOptions.position = options.position || defaultPos;
	finalOptions.position.top += iframeBox?.top ?? 0;
	finalOptions.position.left += iframeBox?.left ?? 0;

	return finalOptions;
};

/**
 * Shows a date picker component. A callback will be invoked when the date (and time) is selected by the user.
 * @memberof module:Jira
 * @method openDatePicker
 * @param {DatePickerOptions} options - Configuration of the date picker.
 * @noDemo
 * @example
 * var dateField = document.querySelector("#date-field");
 * var dateTrigger = document.querySelector("#date-trigger");
 *
 * dateTrigger.addEventListener("click", function(e) {
 *   e.preventDefault();
 *   AP.jira.openDatePicker({
 *     element: dateTrigger,
 *     date: "2011-12-13T15:20+01:00",
 *     showTime: true,
 *     onSelect: function (isoDate, date) {
 *       dateField.value = date;
 *       dateField.setAttribute("data-iso", isoDate);
 *       dateField.focus();
 *     }
 *   });
 * });
 */
export const openDatePicker = (
	options: DatePickerOptions,
	callback: DatePickerCallback,
): DatePickerOptions => {
	const finalOptions = _options(options, callback);
	show(finalOptions);
	return finalOptions;
};
